import { createContext, useContext } from "react";

export const CATALOG_NEW_ITEM_ID = "new";

export type CatalogNavContextValue = {
  setDirty: (dirty: boolean) => void;
  allowNavigate: (to: string) => void;
};

export const CatalogNavContext = createContext<CatalogNavContextValue | null>(
  null,
);

export const useCatalogNav = () => {
  const context = useContext(CatalogNavContext);
  if (!context) {
    throw new Error("useCatalogNav must be used within CatalogNavProvider");
  }
  return context;
};
